import { createStore } from 'vuex'

export default createStore({
  state: {

    //Globale Settings
    showGeraetetypenAnzahl: false,
    Kunde: "",
    Logo: "",
    LogoHoehe: "",
    LogoBreite: "",

    AppTitle: "",
    AppTitleShort: "",

    AGBDisplayname: "",
    AGBpath: "",
    DatenschutzDisplayname: "",
    Datenschutzpath: "",
    SonstigesDokumentDisplayname: "",
    SonstigesDokumentpath: "",
    MaxFileSize: 0,
    PreisFile: "",
    AnleitungFile: "",
    ImpressumVorhanden: false,
    ImpressumPath: "",

    Aaschlussortmodul: false,
    CookieBannerEingeschaltet: false,
    VerwaltungEinschalten: false,
    Bankenmodul: false,
    FelderNichtAnzeigen: [],
    VertragsPflichtfelder: [],
    DokumentArten: [],
    BezahlItems: [],
    Konzessionsgebiete: [],
    VoraussichtlicheDauerMonth: [],
    CompanyName: "",

    //Placeholder
    PlaceholderDauer: "",

    //Displaynames
    NameDisplayName: "",
    KontoinhaberDisplayName: "",
    IBANDisplayName: "",
    BICDisplayName: "",
    BankinstitutDisplayName: "",

    KundennummerDisplayName: "",
    FuerPersonDisplayName: "",
    FirmaDisplayName: "",
    AnredeDisplayName: "",
    NachnameDisplayName: "",
    VornameDisplayName: "",
    StrasseDisplayName: "",
    HausnummerDisplayName: "",
    HausNrErgDisplayName: "",
    PlzDisplayName: "",
    OrtDisplayName: "",
    TelefonDisplayName: "",
    Telefon2DisplayName: "",
    MobilDisplayName: "",
    EMailDisplayName: "",
    LandDisplayName: "",

    VerbrauchstelleStrasseDisplayName: "",
    VerbrauchstelleHausnummerDisplayName: "",
    VerbrauchstellePlzDisplayName: "",
    VerbrauchstelleOrtDisplayName: "",
    VerbrauchstelleEtageDisplayName: "",


    GeraeteklassenDisplayName: "",
    BauformDisplayName: "",
    KonzessionsgebietDisplayName: "",
    EinsatzstelleDisplayName: "",
    VoraussichtlicheDauerDisplayName: "",
    LangzeitmieteDisplayName: "",
    ZahlungsartDisplayName: "",
    AusgabeNameDisplayName: "",
    AusgabeVornameDisplayName: "",

    kundenreferenzDisplayName: "",
    ServicePointDisplayName: "",
    EinsatzortDisplayName: "",
    MitAbwasserDisplayName: "",
    EntnahmezweckDisplayName: "",
    StueckHydrantenschluesselDisplayName: "",
    BemerkungenDisplayName: "",

    // Gloal Style Setting
    ButtonRound: "",
    // PasswordReset
    TokenReset: "",
    // Main
    Titel: "",
    Page: 0,
    FehlerCode: 0,
    FehlerText: "",
    FehlerTitle: "",

    // Login
    Login: false,
    Rechte: [],
    RechtReservieren: false,
    RechtSpezial: false,
    RechtDokumentLaden: false,

    activeTab: 0,


    //Registrieren
    Benutzerdaten: {

      Login: "",
      Password: "",
      PasswordSame: "",

      Firma: "",
      Land: "",
      Anrede: "",
      Ausweisnummer: "",
      Vorname: "",
      Nachname: "",
      WeitererVorname: "",

      Telefon: "",
      Telefon2: "",
      Mobil: "",
      EMail: "",

      Strasse: "",
      Hausnummer: 0,
      HausNrErg: "",
      Plz: "",
      Ort: "",
    },

    Code: "",
    Zufallswert: 0,

    //Vertrag
    Vorgangsnummer: 0,
    Kundennummer: "",
    Anrede: "",
    Firma: "",
    Land: "",
    Vorname: "",
    Nachname: "",
    Telefon: "",
    Telefon2: "",
    Mobil: "",
    EMail: "",
    Land: "",
    Laenderliste: [],

    Bauform: null,

    Einsatzstelle: "",
    VoraussichtlicheDauer: null,
    Langzeitmiete: false,
    Zahlungsart: "",
    AusgabeName: "",
    AusgabeVorname: "",
    Konzessionsgebiet: null,

    VerbrauchsstelleStrasse: "",
    VerbrauchsstelleHausnummer: "",
    VerbrauchsstellePlz: "",
    VerbrauchsstelleOrt: "",
    VerbrauchsstelleEtage: "",

    Bank: {
      Kontoinhaber: "",
      Kontonummer: "",
      Name: "",
      Bankleitzahl: 0,
      IBAN: "",
      BIC: "",
    },

    kundenreferenz: "",
    ServicePoint: "",
    Einsatzort: "",
    MitAbwasser: false,
    GeplantesAbholdatum: new Date(),
    StueckHydrantenschluessel: null,
    Entnahmezweck: "",
    Bemerkungen: "",
  },
  mutations: {},
  actions: {},
  getters: {},
  modules: {}
})

